module.exports = __webpack_public_path__ + "img/thumb-up.63d8f678.svg";